var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$slots.default)?_c('PopoutBulkAction',{attrs:{"icon":_vm.icon,"tooltip":_vm.tooltip}},[_vm._t("default")],2):_c('GenericBulkAction',{attrs:{"icon":_vm.icon,"tooltip":_vm.tooltip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }